import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { makeStyles, Grid, Paper, Typography, Slider, FormGroup, FormControlLabel, Switch, } from '@vitessce/styles';
import { DimensionsSVG, } from '@vitessce/icons';
import { useControllerSectionStyles, channelRowContainerSx, channelSliderCellSx, channelSelectorCellSx, channelControlCellSx, } from './styles.js';
const useStyles = makeStyles()(theme => ({
    dimensionsIcon: {
        height: '40px',
        width: '40px',
        '& path': {
            fill: theme.palette.primaryForeground,
        },
    },
    switchFormGroup: {
        float: 'right',
        marginTop: '3px',
    },
    dimensionLabel: {
        padding: 0,
        marginBottom: '0 !important',
        marginTop: '12px !important',
    },
    dimensionSlider: {
        marginTop: '9px',
    },
}));
/**
 * The Z variant of this slider also carries the view's 3D rendering-mode switch.
 * `enable3d` allows a view config to withhold that switch, for data which cannot usefully be
 * volume-rendered. It is a single boolean rather than the legacy `layerController`'s per-layer
 * `disable3d` name list because the beta stack has one switch per view driving the shared
 * `spatialRenderingMode`, and because beta layer names come from the image's own OME metadata
 * (`ImageWrapper.getName()`) rather than from the view config, so a config author has no names to
 * match against.
 */
export default function GlobalDimensionSlider(props) {
    const { label, targetValue, setTargetValue, min = 0, max = 0, spatialRenderingMode = null, setSpatialRenderingMode = null, enable3d = true, } = props;
    const { classes: lcClasses } = useControllerSectionStyles();
    const { classes } = useStyles();
    const isForZ = spatialRenderingMode !== null;
    const is3dMode = spatialRenderingMode === '3D';
    function handleRenderingModeChange(event) {
        setSpatialRenderingMode(event.target.checked ? '3D' : '2D');
        if (!event.target.checked) {
            // From 3D to 2D
            // Need to make sure that the targetZ is an integer
            setTargetValue(Math.floor(targetValue));
        }
    }
    return (_jsx(Grid, { className: lcClasses.layerControllerGrid, children: _jsx(Paper, { elevation: 4, className: lcClasses.layerControllerRoot, children: _jsxs(Grid, { container: true, direction: "row", justifyContent: "space-between", sx: channelRowContainerSx, children: [_jsx(Grid, { size: 1, sx: channelControlCellSx, children: _jsx(DimensionsSVG, { className: classes.dimensionsIcon }) }), _jsx(Grid, { size: 1, sx: channelSelectorCellSx, children: _jsx(Typography, { className: classes.dimensionLabel, children: label }) }), _jsx(Grid, { size: 8, sx: channelSliderCellSx, children: !is3dMode ? (_jsx(Slider, { value: targetValue, min: min, max: max, step: 1, onChange: (e, v) => setTargetValue(v), className: classes.dimensionSlider, valueLabelDisplay: "auto", orientation: "horizontal", disabled: spatialRenderingMode === '3D', "aria-label": `${label}-slice slider` })) : null }), _jsx(Grid, { size: 2, sx: channelControlCellSx, children: isForZ && enable3d ? (_jsx(FormGroup, { row: true, className: classes.switchFormGroup, children: _jsx(FormControlLabel, { control: _jsx(Switch, { color: "primary", checked: spatialRenderingMode === '3D', onChange: handleRenderingModeChange, name: "is3dMode" }), label: "3D" }) })) : null })] }) }) }));
}
//# sourceMappingURL=GlobalDimensionSlider.js.map